import {RootStore} from '../index';
import {action, makeAutoObservable} from "mobx";
import QuizModel from "../../model/QuizModel";


export class PageQuizStore {


    array = [
        {
            id: 0,
            checkbox: false,
            radioButton: true,
            title: "Использование сайта",
            subTitle: "Как часто вы пользуетесь нашим порталом (заходите на портал для просмотра либо заказа товаров)?",
            answerCheckBox: [],
            answerRadioButton: ["Более 1 раза в неделю", "Более 2 раз в неделю", "1 раз в две недели", "1 раз в месяц", "Реже"],
            inputField: false,
            inputTittle: "Укажите, причину.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 1,
            checkbox: false,
            radioButton: true,
            title: "Навигация",
            subTitle: "Устраивает ли вас общая навигация по порталу (работа с меню, в том числе с меню каталога)?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 2,
            checkbox: true,
            radioButton: false,
            title: "Устройства",
            subTitle: "С какого устройства вы пользуетесь порталом? ",
            answerCheckBox: ["ПК (персональный компьютер)", "Laptop (ноутбук)", "Планшет", "Телефон"],
            answerRadioButton: [],
            inputField: true,
            inputTittle: "Укажите другое",
            indexValueSelected: "",
            inputValue: "",
            indexValueSelectedCheckBox: [],
        },
        {
            id: 3,
            checkbox: false,
            radioButton: true,
            title: "Описание товаров",
            subTitle: "Все ли вас устраивает в текущей подаче материала (описание товаров)?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 4,
            checkbox: false,
            radioButton: true,
            title: "Оформление заказа",
            subTitle: "Все ли вас устраивает, по текущей реализации работы корзины и вариантом оформления заказа?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 5,
            checkbox: false,
            radioButton: true,
            title: "Уведомления",
            subTitle: "Нужно ли добавить уведомления при появлении новых товаров или скидок?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 6,
            checkbox: false,
            radioButton: true,
            title: "Обратная связь",
            subTitle: "Устраивает ли вас обратная связь в случае возникновения вопросов?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 7,
            checkbox: false,
            radioButton: true,
            title: "Мобильная версия",
            subTitle: "Устраивает ли вас текущая мобильная версия?",
            answerCheckBox: [],
            answerRadioButton: ["Да", "Нет"],
            inputField: false,
            inputTittle: "Укажите, что именно не устраивает.",
            indexValueSelected: "",
            inputValue: ""
        },
        {
            id: 8,
            checkbox: true,
            radioButton: false,
            title: "Операционная система",
            subTitle: "Под какой операционной системой работает ваше мобильное устройство?",
            answerCheckBox: ["iPhone (ios)", "Android"],
            answerRadioButton: [],
            inputField: true,
            inputTittle: "Укажите другое",
            indexValueSelected: "",
            inputValue: "",
            indexValueSelectedCheckBox: [],
        },
        {
            id: 9,
            checkbox: false,
            radioButton: false,
            title: "Ваши пожелания",
            subTitle: "Что бы вы хотели видеть на портале (ваши пожелания)?",
            answerCheckBox: [],
            answerRadioButton: [],
            inputField: true,
            inputTittle: "Ваш вариант (больше новостей, акции и т.п.)",
            indexValueSelected: "",
            inputValue: ""
        },];

    value = 0
    valueLess = false
    open = false
    openThankWindow = false
    arrayValue = this.array
    openDopInfo = false
    selectedIndex = 0
    showDopInfo = []
    arrayAnswersFromDB = []

    private rootStore: RootStore | undefined;

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;

    }

    @action init() {
        // if (this.rootStore?.mainStore.openQuiz === true) {
        //     this.open = true
        // }
        QuizModel.getAnswers(this.setAnswers, this.setError)

    }

    @action setAnswers = (result: any) => {
        if (result) {
            this.arrayAnswersFromDB = result.data
        }
    }

    @action handleChange = (event: any, newValue: number) => {
        this.value = newValue
        this.valueLess = false
    };

    @action moveLeft = (newValue: number) => {
        this.value = newValue + 1
    };

    @action moveRight = (newValue: number) => {
        if (newValue > 0) {
            this.value = newValue - 1
        }
        ;
    };

    @action handleChangeLessValue = (value: string, ind: number, checkbox: boolean) => {

        if (!checkbox) {
            for (let i = 0; i < this.arrayValue.length; i++) {
                if (this.arrayValue[i].id === ind) {
                    this.arrayValue[i].indexValueSelected = value
                }
            }
        } else {
            for (let i = 0; i < this.arrayValue.length; i++) {
                if (this.arrayValue[i].id === ind) {
                    // @ts-ignore
                    if (this.arrayValue[i].indexValueSelectedCheckBox.includes(value)) {
                        let myArray = this.arrayValue[i].indexValueSelectedCheckBox
                        // @ts-ignore
                        let myIndex = myArray.indexOf(value);

                        if (myIndex !== -1) {
                            // @ts-ignore
                            myArray.splice(myIndex, 1);
                        }
                        this.arrayValue[i].indexValueSelectedCheckBox = myArray

                    } else {
                        // @ts-ignore
                        this.arrayValue[i].indexValueSelectedCheckBox.push(value)
                    }

                }
            }
        }


        if (value === "Реже" || value === "Нет") {
            this.valueLess = true
        } else {
            this.valueLess = false
        }

    };
    @action handleChangeInputValue = (value: string, ind: number) => {
        for (let i = 0; i < this.arrayValue.length; i++) {
            if (this.arrayValue[i].id === ind) {
                this.arrayValue[i].inputValue = value
            }
        }
    };

    @action handleOpen = () => this.open = true;
    @action handleClose = () => this.open = false;
    @action handleCloseThankWindow = () => this.openThankWindow = false;
    @action handleOpenDopInfo = (val: boolean, indexVal: number) => {
        this.showDopInfo = []
        this.openDopInfo = !val;
        this.selectedIndex = indexVal
        this.arrayAnswersFromDB.forEach((item: any) =>
            // @ts-ignore
            item.data[indexVal].inputValue !== "" ? this.showDopInfo.push({
                // @ts-ignore
                userId: item.user.email,
                // @ts-ignore
                inputValue: item.data[indexVal].inputValue,
                // @ts-ignore
                createAt: item.createdAt
            }) : null
        )
    }

    @action
    postAnswer = () => {
        QuizModel.postAnswers(this.arrayValue, this.setQuiz, this.setError)
    }

    @action setError = (error: any) => {
        console.log(error)
    }

    @action setQuiz = (result: any) => {
        if (result.status === 201) {
            this.rootStore?.mainStore.init()
            this.openThankWindow = true
        }
    }

}
